const Form083TC = {
    stepName: {
        importantNotes: "重要事項",
        teacherFillInTheSupplementary: "補充頁\n(由教師填寫)",
        schoolOfInformation: "學校管理人員填寫小學教員改編為學位教師表格",
        changesInSalaryDetails: "薪酬詳情的變化",
        salaryParticulars: "薪酬詳情",
        noteInformation: "備註資料",
        attachment: "附件",
        certification: "認證",
        confirmation: "確認",
        detailsOfRegrading: "改編職系詳情",
        approverCertification: "聲明",
        annex: "教職員編制及在職人數表附件",
        formA: "認證",
        formB: "基本資料",
    },
    label: {
        header: {
            headerOne: "重要事項",
        },
        statement: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamSignCheck: "本人明白需透過「智方便+」帳戶以辧理申請。",
        certificationCheckboxText:
            "本人確認「補充頁」所載的資料正確無誤及完整。",
        pointOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46（44B）",
            fortyFive: "45（44A）",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36（33C）",
            thirtyFive: "35（33B）",
            thirtyFour: "34（33A）",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        schoolSessionOption: {
            am: "上午",
            pm: "下午",
            wholeDay: "全日",
        },
        committeeOption: {
            smc: "校董會",
            imc: "法團校董會",
        },

        teacherFillInTheSupplementary: {
            header: "小學教員改編為學位教師 ─補充頁",
            header1: "(如改編後的薪金是以重新評估的方法計算，請教師填寫本頁)",
            schoolName1: "學校名稱",
            schoolCode1: "學校代碼",
            information: "基本資料",
            personalInformation: "個人資料",
            title: "稱謂",
            titleOption: {
                Mr: "先生",
                Miss: "小姐",
                Mrs: "太太",
                Ms: "女士",
            },
            nameInEnglish: "教師英文姓名",
            nameInChinese: "教師中文姓名",
            hkid1: "香港身份證號碼",
            srn1: "員工檔號",
            appointmentParticulars: "聘任資料 ",
            appointmentParticulars1:
                "﹝如有需要，請另頁填寫。持有非本地學歷及／或專業訓練，請提交評審結果及／或其他相關資料詳情。﹞",
            academicQualifications: "學術資格",
            collegeOrUniversityOrInstitute: "學院／大學／院校",
            certificateOrDiplomaOrDegreeObtained: "獲頒的證書／文憑／學位",
            dateOfAward: "頒授日期(日)",
            dateOfAwardmm: "頒授日期(月)",
            dateOfAwardyy: "頒授日期(年)",
            dateOfAwardMmList: {
                jan: "01",
                feb: "02",
                mar: "03",
                apr: "04",
                may: "05",
                jun: "06",
                jul: "07",
                aug: "08",
                sep: "09",
                oct: "10",
                nov: "11",
                dec: "12",
            },
            majorAndMinorSubjects: "主修及副修科目",
            professionalTraining: "專業培訓",
            schoolOrCollegeOrUniversityOrInstitute: "學校／學院／大學／院校",
            certificateOrDiplomaOrDegreeObtained1: "獲頒的證書／文憑／學位",
            dateOfAward1: "頒授日期(日)",
            dateOfAward1mm: "頒授日期(月)",
            dateOfAward1yy: "頒授日期(年)",
            courseOrSubject: "修讀課程／科目",
            teachingExperience: "教學經驗",
            schoolOrInstitute: "學校／院校",
            type: "所屬類別",
            rank: "職級",
            form: "由(日／月／年)",
            to: "至(日／月／年)",
            fullOrPartTime: "全職或兼任教師",
            fullOrPartTimeOption: {
                full: "全職教師",
                partTime: "兼任教師",
            },
            partTime: "如屬兼任教師，請闡述佔全職工作的比例",
            sourceOfFunding: "經費來源",
            tooltip: {
                tooltip1:
                    "請指明學校所屬類別，例如資助、官立、私立、按額津貼、買位、直資……",
                tooltip2: "如屬兼任教師，請闡述佔全職工作的比例。",
                tooltip3:
                    "請闡述經費來源，例如：薪金津貼、優質教育基金、營辦開支整筆津貼、學校發展津貼、私人款項……",
            },
            noPayLeaveTaken: "曾放取的無薪假期﹝如有﹞",
            schoolOrInstitute1: "學校／院校",
            form1: "由 (日／月／年)",
            to1: "至 (日／月／年)",
            note: "本人確認上述資料正確無誤及完整。",
            date: "日期",
            signatureOfTeache: "教師簽署",
            note1: "本人已根據有關的《資助則例》的規定，核對「補充頁」的資料已完整填妥，並核實有關資料，亦明白如有關資料不齊全，教育局不會處理本表格。",
            note2: "本人確認為有關人員評估的薪額正確無誤。",
            supervisorOrSchoolHead: "校監／校長",
            supervisorOrSchoolHeadOption: {
                supervisor: "校監",
                schoolHead: "校長",
            },
            nameOfSchoolSupervisorOrSchoolHead: "校監／校長姓名",
            nameDescription: "姓名（如香港身份證所示）",
        },

        schoolOfInformation: "學校資料",
        titleNote: {
            note1: "正本及第一副本：",
            note2: "教育局公積金組﹝公積金組把第一副本轉交教育局薪金核實小組﹞",
            // note3: "第二副本：",
            note4: "第二副本：",
            note5: "學校所屬的教育局區域教育服務處 [經辦人: 高級學校發展主任 ",
            note6: "]",
            note7: "第三副本：",
            note8: "學校存檔",
        },
        ssdoOption: {
            Central_and_Western: "中西區",
            Southern: "南區",
            Wan_Chai: "灣仔區",
            Islands: "離島區",
            HKEast: "港島東區",
            Kowloon_City: "九龍城區",
            Sham_Shui_Po: "深水埗區",
            Sai_Kung: "西貢區",
            Kwun_Tong: "觀塘區",
            Wong_Tai_Sin: "黃大仙區",
            Yau_Tsim_Mong: "油尖旺區",
            Tai_Po: "大埔區",
            North: "北區",
            Sha_Tin: "沙田區",
            Kwai_Chung_and_Tsing_Yi: "葵青區",
            Tsuen_Wan: "荃灣區",
            Tuen_Mun: "屯門區",
            Yuen_Long: "元朗區",
        },
        ssdo: "高級學校發展主任",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        schoolSession: "授課時間",
        // schoolContactPerson: "學校聯絡人",
        tel: "電話號碼",
        contactAndTelText1: "學校聯絡人",
        contactAndTelText2: "及其電話號碼",
        contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",
        detailsOfRegrading: "改編職系詳情",
        committee: "校董會",
        mode: "已批准下列署任安排",
        ref: "檔號",
        date: "日期",
        committeeText1: "1. ",
        committeeText2: "已批准下列的改編職系安排﹝檔號",
        committeeText3: "及日期：",
        committeeText4: "﹞",
        committeeText5: "，而有關人員的薪金資料需因此而作出以下的改動：",
        // two page
        // changesInSalaryDetails: "薪金改動詳情",
        englishName: "教師英文姓名",
        chineseName: "教師中文姓名",
        hkid: "香港身份證號碼",
        srn: "員工檔號",
        beforeRegrading: "改編前",
        monthlySalary: "薪金(總薪級表薪點)改編前",
        rank: "職級(改編前)",
        uponRegrading: "改編後",
        monthlySalary1: "薪金(總薪級表薪點)改編後",
        monthlySalaryTemp: "薪金",
        mps: "(總薪級表薪點)",
        rank1: "職級(改編後)",
        // actingPeriod: "署任期",
        effectiveDate: "生效日期",
        incrementalDate: "增薪日期(01/月)",
        incrementalDateList: {
            0: "NA",
            1: "01",
            2: "02",
            3: "03",
            4: "04",
            5: "05",
            6: "06",
            7: "07",
            8: "08",
            9: "09",
            10: "10",
            11: "11",
            12: "12",
        },
        dateOfNextIncrement: "下次增薪日期(01/月/年)",
        salaryBar: "薪金關限 (如適用)(總薪級表薪點)",
        salaryBarOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46(44B)",
            fortyFive: "45(44A)",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36(33C)",
            thirtyFive: "35(33B)",
            thirtyFour: "34(33A)",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
            na: "N/A",
        },
        maxSalary: "頂薪點 (總薪級表薪點)",
        certification: "聲明",
        declaration:
            "2. 謹此聲明，本人是根據已有的學位教師空缺作出上述改編職系的安排 (請在適當的方格內加上“ √ ”)",
        declarationList: {
            declaration1: "上述 ",
            declaration2:
                "上述學生輔導教師是以提供給辦學團體的學位教師職位而改編職系的。",
        },
        declaration1: {
            declaration2: " 是以其學校核准編制內的學位教師職位而改編職系的。在",
            declaration3: "附件",
            declaration4:
                "內的教職員編制及在職人數表顯示有空缺為上述教師改編職系。",
        },
        teacherOrstudent: {
            teacher: "教師",
            student: "學生輔導教師",
        },
        note: "3. 本人現確認在本表格第1至2段內及「補充頁」所載的資料均正確無誤，本人亦承諾有關改編事宜不會令學位教師數目超逾已核准的學位教師職位編制。本人並承諾本校會把多付的薪金津貼退還教育局。",
        dialogText: "請先選擇學校",
        attachmentForSchool: "{{school}}附件",
        attachment: "附件",
        chooseTheSchool: "選擇學校（小學／特殊學校）",
        chooseTheSchoolOption: {
            primarySchool: "小學",
            specialSchool: "特殊學校",
        },
        personalStatement: "陳訴",
        title: "個人資料收集聲明",
        // attachment: "教職員編制及在職人數表附件",
        attachmentLink: "點擊此處下載附件表格",
        termsConditions: "本人已閱讀、明白及同意上述條款及細則。",
        confirm: "確認",
        collectionStatement: "個人資料收集聲明",
        completedBySchoolHead: "此欄由校監／校長填寫",
    },
    note: {
        note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途：",
        note2: "每份表格只適用於一項改編職系安排。",
        note3: "如改編後的薪金是以重新評估的方法",
        note3a: "計算，請填寫「補充頁」。",
        note3b: "請在填寫前，詳細閱讀個人資料收集聲明。",
        note4: "請確保教師知悉本表格及「補充頁」(如適用)所填報的內容，並已閱讀個人資料收集聲明。",
        // note5: "1.在晉升或署任安排的生效日期前須完成所需的程序（包括校董會／法團校董會的批准）。在一般情況下，晉升或署任安排的生效日期不具追溯效力。",
        // note6: "2.資助中學、特殊中學或設有中小學部的特殊學校中學部的全職常額首席學位教師／高級學位教師／學位教師倘獲推薦及批准署任較高職級的一級校長／二級校長／首席學位教師／高級學位教師職位並擔任專責職務，而其合資格署任期達30個曆日或以上，可獲發放署任津貼。",
        // note7: "3.如署任人員連續休假超過3個工作天影響其合資格署任期的計算及／或涉及署任津貼的扣減（包括休假日及當中的公眾假期和星期日），學校須填寫署任安排﹝署任教師休假／缺勤超逾連續3天以上須調整署任津貼的通知﹞表格通知本局調整署任津貼。",
        // note8: "4.詳情請參閱教育局通告第8／2004號的附錄。如有關署任津貼率有更改，請填寫署任安排﹝署任津貼率由90%調整至100%的通知﹞表格。",
        // note9: "5.在2019／20學年起，在教師職位學位化政策全面推行的情況下，資助學校核准編制內的所有教席均為學位教師職位。在2019／20學年起，非學位職系教師的晉升機制將不獲保留。換句話說，非學位教師職系不應該有任何新的晉升及署任（有待實任）安排。",
        note10: "6.教育局將會對每份署任申請作出編制預先核查。如有關署任教師於委任日已超逾該校的核准教學人員編制，在釐清該署任安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
        //
        note11: "2.在附件內的教職員編制及在職人數表顯示有空缺作出上述署任安排。",
        note12: "3.有關校長職位的署任，請提供已獲教育局事先批准的詳情（檔號及日期：",
        note12Last: "）。",
        note13: "4.上述教師獲確認實際晉升",
        note13b: "時，本人會通知教育局，並呈交《教職員晉升事宜》表格。",
        note14: "5.本人承諾，若上述教師的署任期未能符合教育局通告第8／2004號第2段有關發放署任津貼的合資格署任期的各項規定",
        note14b:
            "，本人會立即通知教育局公積金組，並將通知副本送交有關的學校發展主任。",
        note15: "6.本人現確認在本表格第1至3段內所載的資料均正確無誤。本人承諾有關署任事宜不會令擔任晉升職級的教學／非教學人員的人數超逾已核准的編制。本人並承諾本校會把多付的薪金津貼退還教育局。",
        //
        // note16: "辦理與聘用有關的事宜；",
        // note17: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        // note18: "進行核數工作； ",
        // note19: "進行研究及統計資料，以便規劃教育服務；",
        // note20: "處理有關教育專業人員發展的事宜；",
        // note21: "執行《教育條例》、《教育規例》及附屬《補助／津貼學校公積金規則》（第279章）。",
        a: "辦理與聘用有關的事宜；",
        b: "處理發放薪金津貼及其他政府資助；",
        c: "計算公積金的供款；",
        d: "進行核數工作；",
        e: "進行研究及統計資料，以便規劃教育服務；",
        f: "處理有關教育專業人員發展的事宜；",
        g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
        note22: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        note23: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        note24: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note25: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
        // five page
    },
    noteList: {
        noteOne:
            "以重新評估方法計算薪金，即以當時生效的起薪點另加經驗增薪點(如適用)來計算支薪點。",
        noteTwo:
            "在改編職系的生效日期前須完成所需的程序(包括校董會／法團校董會的批准)。在一般情況下，改編職系的生效日期不具追溯效力。",
        noteThree:
            "教育局將會對每份改編職系申請作出編制預先核查。如有關改編職系的教師於委任日已超逾該校的核准教學人員編制，在釐清該改編職系安排是否符合編制人數之前，該薪金津貼將不會發放給學校。",
        // noteFour:
        //     "詳情請參閱教育局通告第8／2004號的附錄。如有關署任津貼率有更改，請填寫署任安排﹝署任津貼率由90%調整至100%的通知﹞表格。",
        // noteFive:
        //     "校長職位的署任必須事先獲教育局批准。如有查詢，請聯絡有關學校發展主任。",
    },
    errorMsg: {
        E001: "改編後薪金不能高於頂薪點",
        E002: "兩者不能同時選擇",
        hkidEmpty: "括號內的值不能為空",
        schoolName1: "請輸入一個有效的學校名稱", //學校名稱
        schoolCode1: "請輸入一個有效的學校代碼", //學校代碼
        nameInEnglish: "請輸入一個有效的英文名", //英文名
        nameInChinese: "請輸入一個有效的中文名", //中文名
        englishName: "請輸入一個有效的教師英文姓名",
        chineseName: "請輸入一個有效的教師中文姓名",
        numberOnly: "請輸入一個有效的8位數字",
        monthlySalary: "請輸入一個有效的薪金(總薪級表薪點)",
        refNum: "請輸入一個有效檔號",
        Note001:
            "注 1.所有晉升教師或代理任命的必要程式都應在生效日期之前完成，包括獲得校董會/校董會的批准。 一般情況下，晉升日期和代理任命日期不具有追溯效力。",
        telMax: "電話號碼必須為最多12位數",
        srnMin: "員工檔號必須為8位數",
        schoolCodeMin: "學校代碼必須為4位數",
    },
};
export default Form083TC;
